import React, { useEffect, useRef } from 'react';
import './About.css';

function About({ onClose, scrollToSection }) {
  const genderCriticalRef = useRef(null);

  useEffect(() => {
    if (scrollToSection === 'gender-critical' && genderCriticalRef.current) {
      setTimeout(() => {
        genderCriticalRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, [scrollToSection]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="page-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <h1>About</h1>
        
        <div className="page-content">
          <section id="gender-critical" ref={genderCriticalRef}>
            <h2>What is Gender Critical?</h2>
            <p>
              <strong>Gender critical</strong> refers to a perspective that critically examines the concept 
              of gender identity and its impact on sex-based rights and protections. Gender critical activists 
              believe that:
            </p>
            <ul>
              <li>
                <strong>Sex is biological and immutable:</strong> Sex is determined by biological characteristics 
                (chromosomes, reproductive anatomy, hormones) and cannot be changed.
              </li>
              <li>
                <strong>Gender is a social construct:</strong> Gender roles, expectations, and stereotypes are 
                socially constructed and can be harmful when they limit individuals based on their sex.
              </li>
              <li>
                <strong>Sex-based rights matter:</strong> Legal protections and spaces based on biological sex 
                are necessary for the safety, privacy, and equality of women and girls.
              </li>
              <li>
                <strong>Women's rights are sex-based:</strong> The rights and protections that women have fought 
                for throughout history are based on biological sex, not gender identity.
              </li>
            </ul>
            <p>
              Gender critical activists advocate for maintaining sex-based legal protections, preserving 
              women-only spaces, and ensuring that policies designed to address sex-based discrimination 
              are not undermined by conflating sex with gender identity.
            </p>
            <p>
              This perspective emphasizes the importance of material reality and biological sex in understanding 
              and addressing the oppression of women, while also recognizing that gender roles and stereotypes 
              should be challenged and dismantled.
            </p>
          </section>

          <section>
            <h2>About This Platform</h2>
            <p>
              This platform was created by and for biological women who hold gender critical beliefs. 
              It provides a space where women can freely discuss:
            </p>
            <ul>
              <li>Sex-based rights and protections</li>
              <li>Gender ideology and its impact on women's rights</li>
              <li>The erosion of women's spaces and services</li>
              <li>Issues affecting women and girls</li>
              <li>Feminist perspectives and analysis</li>
            </ul>
            <p>
              We believe in free speech, respectful dialogue, and the importance of spaces where women 
              can discuss these issues without fear of censorship or harassment.
            </p>
          </section>

          <section>
            <h2>Community Guidelines</h2>
            <p>
              This is a moderated space. Please review our full <strong>Community Guidelines</strong> for
              detailed information about acceptable use, prohibited content (including no doxxing of private
              individuals), and moderation policies. In summary, we expect all users to:
            </p>
            <ul>
              <li>Respect other members and engage in constructive dialogue</li>
              <li>Never share personal identifying information (doxxing)</li>
              <li>No threats, harassment, or hate speech</li>
              <li>Follow content moderation policies</li>
              <li>Report inappropriate content or behavior</li>
              <li>Maintain the privacy and safety of the community</li>
            </ul>
            <p>
              Accounts that violate community guidelines may be frozen or removed. Content that receives
              multiple reports will be reviewed by administrators. See the full Community Guidelines
              for comprehensive details on expectations and policies.
            </p>
          </section>

          <section>
            <h2>Verification</h2>
            <p>
              Basic accounts can post and upvote on the forum. Verified accounts, after manual review 
              by administrators, gain access to additional private communities including Discord servers 
              and WhatsApp groups for more intimate discussion and networking.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default About;

